import type { ReactNode } from 'react';
import type { IconName } from '../icons';
import { Icon } from './Icon';
import { SheetShell } from './Sheet';

// Bottom action sheet (Authority §22 "选择器 = 底部 sheet"; the 01 `⋮` row menus and their sub-steps
// open here). A list of one-tap actions in the row-card idiom (icon tile · label), an optional
// danger tone, and — like every sheet — Close in the header plus the backdrop (OC §9.4).
// A row that cannot be chosen stays an enabled button marked aria-disabled, and its tap is ignored here.
// (On the Owner's iPhone, 2026-09-12, pressing a row lit the row below it: WebKit mapped touches too low
// under a native scroll-view inset — fixed in capacitor.config.ts, not by anything in this component.)
export interface ActionSheetItem {
  key: string;
  label: string;
  detail?: string;
  icon?: IconName;
  tone?: 'default' | 'danger';
  disabled?: boolean;
  onSelect: () => void;
  testId?: string;
}

export function ActionSheet(props: {
  title: string;
  subtitle?: string;
  items: ActionSheetItem[];
  onClose: () => void;
  layer?: 'base' | 'over';
  children?: ReactNode;
  footer?: ReactNode;
  testId?: string;
}) {
  return (
    <SheetShell title={props.title} subtitle={props.subtitle} onClose={props.onClose} layer={props.layer} footer={props.footer} testId={props.testId}>
      {props.children}
      <div className="action-list" role="menu">
        {props.items.map((item) => (
          <button
            key={item.key}
            type="button"
            role="menuitem"
            className={`action-row ${item.tone === 'danger' ? 'action-row-danger' : ''}`}
            onClick={() => {
              if (!item.disabled) item.onSelect();
            }}
            aria-disabled={item.disabled ? true : undefined}
            data-testid={item.testId}
          >
            {item.icon ? (
              <span className={`icon-tile ${item.tone === 'danger' ? 'icon-tile-error' : 'icon-tile-soft'}`}>
                <Icon name={item.icon} />
              </span>
            ) : null}
            <span className="action-row-main">
              <span className="action-row-label">{item.label}</span>
              {item.detail ? <span className="action-row-detail">{item.detail}</span> : null}
            </span>
          </button>
        ))}
      </div>
    </SheetShell>
  );
}
